export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_APPFOLIO = 'AppFolio';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_BUILDIUM = 'Buildium';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_PROPERTYWARE = 'Propertyware';
export const PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENTVINE = 'Rentvine';

export const PROPERTY_MANAGEMENT_SOFTWARE_INTEGRATION_TYPE_REPORT = 'Report';
export const PROPERTY_MANAGEMENT_SOFTWARE_INTEGRATION_TYPE_API = 'API';
export const PROPERTY_MANAGEMENT_SOFTWARE_INTEGRATION_TYPE_SCRAPER = 'Scraper';
